export default "__VITE_ASSET__DXkWIHLO__"